export default class SERVICE_URL {   
    static LOGGER_URL = "https://b2bapplog.ascent24.io/b2b.ui";
    // static BASE_URL = "https://b2bapi.ascent24.io/"; have stored these values in env
    // static DEV_BASE_URL = "https://dev.b2bapi.ascent24.io/";

    //List of methods
    static EDIT_STATE = "api/tools/editState";
    static DELETE_STATE = "api/tools/deleteState";
    static ADD_COUNTRY = "api/tools/addCountry";
    static ADD_STATE = "api/tools/addState";
    static ADD_ORG_CURRENCY = "api/tools/addOrgCurrency";
    static EDIT_ORG_CURRENCY = "api/tools/editOrgCurrency";

    static UPDATE_EXTENSION_SETUP = 'api/tools/updateExtension_Setup';
    static GET_EXTENSION_SETUP = 'api/tools/getExtension_Setup';

    static GET_MINI_BOOKING_LS = "api/dashboard/getMiniBookingList";
    static GET_MINITCKT_QUEUE = "api/dashboard/getMiniTicketingQueueList";
    static GET_BOOKING_NUMBER = "api/dashboard/getBookingNumber";

    static GET_B2B_SYS_BOOKING_NUM = 'api/sysdashboard/b2b/getbookingnumber';
    static GET_B2B_SYS_SEARCH_COUNT = 'api/sysdashboard/b2b/searchcount';
    static GET_B2B_SYS_WEEKLY_SALES = 'api/sysdashboard/b2b/weeklysales';
    static API_GET_DELETE_FLIGHT_FARE = "api/b2b/crs/deleteFlightFare";
    static API_CLONE_FARE_RULE = "api/b2b/crs/cloneFareRule";
    static API_DELETE_FARE_RULE = "api/b2b/crs/deleteFareRule";

    static API_GET_FARE_RULE = "api/b2b/crs/getFareRule";
    static API_GET_FLIGHT_FARE = "api/b2b/crs/getFlightFare";
    static API_GET_FLIGHT_SCHEDULE = "api/b2b/crs/getFlightSchedule";
    static API_GET_FLIGHT_SCHEDULE_ROUTES = "api/b2b/crs/getFlightScheduleRoutes";
    static API_GET_TAX_SETUP = "api/b2b/crs/getTaxSetup";
    static API_GET_DELETE_FLIGHT_SCHEDULE = "api/b2b/crs/deleteFlightSchedule";
    static API_CHANGE_FLIGHT_SCHEDULE_STATUS = "api/b2b/crs/changeFlightScheduleStatus";
    static GET_ALL_AIRLINES= 'api/b2b/crs/getAllAirlines';
    static API_CREATE_FLIGHT_SCHEDULE= 'api/b2b/crs/createFlightSchedule';
    static API_UPDATE_FLIGHT_SCHEDULE= 'api/b2b/crs/updateFlightSchedule';
    static API_CREATE_FLIGHT_FARE = "api/b2b/crs/createFlightFare";
    static API_UPDATE_FLIGHT_FARE = "api/b2b/crs/updateFlightFare";
    static API_IMPORT_VALIDATION_FLIGHT_FARE="api/b2b/crs/importValidationFlightFare";
    static API_IMPORT_FLIGHT_FARE = "api/b2b/crs/importFlightFare";
    static API_CREATE_FARE_RULE = "api/b2b/crs/createFareRule";
    static API_UPDATE_FARE_RULE = "api/b2b/crs/updateFareRule";
    static API_CREATE_TAX_SETUP = "api/b2b/crs/createTaxSetup";
    static API_UPDATE_TAX_SETUP = "api/b2b/crs/updateTaxSetup";
    static API_DELETE_TAX_SETUP ='api/b2b/crs/deleteTaxSetup'
    static API_CREATE_HOTEL= 'api/hms/createHotel';
    static API_UPDATE_HOTEL = "api/hms/updateHotel";
    static API_DELETE_HOTEL = "api/hms/deleteHotel";
    static API_GET_HMS_ALL_EMUMS = "api/hms/getHmsAllEnums";
    static API_GET_CRS_ALL_EMUMS = "api/b2b/crs/getAllCrsEnum";
    static API_GET_HMS_USER_PERMISSION = "api/hms/getHmsUserPermission";
    static API_GET_HOTEL_ROOM_IMAGE = 'api/hms/getHotelRoomImages';
    static API_UPDATE_HOTEL_ROOM_IMAGE = 'api/hms/UploadHotelRoomImages';
    static API_DELETE_HOTEL_ROOM_IMAGE = 'api/hms/deleteHotelRoomImage';
    static API_CREATE_HMS_USER = "api/hms/createHmsUser";
    static API_GET_ALL_HMS_USERS = 'api/hms/getAllUser';
    static API_UPDATE_HMS_USER = "api/hms/updateHmsUser";
 


    static GET_SYS_BOOKING_NUMBER = "api/sysdashboard/getbookingnumber";
    static GET_USER_LOGIN_ACTVITY = "api/sysdashboard/userloginactivity";
    static GET_SEARCH_COUNT = "api/sysdashboard/searchcount";
    static GET_WEEKLY_SALES = "api/sysdashboard/weeklysales";
    static GET_AGENT_SALES = 'api/sysdashboard/agentsales';
    static GET_B2B_AGENT_SALES = 'api/sysdashboard/agentsales_b2b';
    static GET_DAY_TO_DAY_SALES = 'api/sysdashboard/day-to-day-sales';

    static CREATE_ROLE = "/api/userManagement/createrole";

    static GET_AGENT_SELECTED_CURRENCY = "/getAgentSelectedCurrencies";
    static GET_COUNTRY_LIST = "api/country/getCountries";
    static GET_CAPTCHA = "api/registration/getcaptcha";
    static GET_SIGNIN_STATUS = "api/auth/signin";
    static CREATE_AGENT = "api/registration/createagent";
    static EXCHANGE_RATE = "api/currency/getExRateForEdit";
    static LANGUAGE_LIST = "api/utils/getLang";
    static LOG_OUT = "api/auth/logout";

    static SAVE_EXCHANGE_RATE = "api/currency/updateExRate";
    static CREATE_USER = "/api/userManagement/createUser";
    static GET_All_USER = "/api/usermanagement/getallusers";
    static UPDATE_USER = "/api/userManagement/updateUser";
    static GET_ALL_AGENT = "api/agent/getallagents";
    static GET_USER_ROLES = "api/userManagement/getRoles";
    static API_VALIDATE_TOKEN = "api/userManagement/validateToken";

    static CHANGE_PASSWORD = "api/user/changepassword";
    static GET_AGENT_DETAILS = "api/agent/getagentdetails";
    static GET_ADMIN_SIGNIN_STATUS = "api/auth/admin/signin";
    static GET_STATE_LIST = "api/utils/getStates";
    static GET_CURRENCY_LIST = "api/currency/getCurrency";
    static GET_CURRENCY_FOR_EDIT= "api/tools/getCurrencyForEdit";

    static GET_ORG_CURRENCY = "api/pricing/getOrgCurrencies";
    static PAYMENT_METHOD = "paymethodURL";
    static PAYMENT_SCHEDULE = "api/registration/getPostpaidSchedule";
    static GET_ROUTES = "api/booking/getroutes";
    static GET_SYSTEM_TOPUP = "api/system/topup";
    static GET_SEARCH_RESULT = "api/booking/search";
    static GET_SEARCH_WITHOUT_MARKUP = "api/booking/searchWithoutMarkup";

    static GET_PRICING_SEARCH = "api/booking/pricing";
    static API_UPDATE_PAYMENT_SETTINGS = "api/payment/updatePaymentSettings";
    static API_CREATE_PAYMENT_SETTINGS = "api/payment/createPaymentSettings";
    static API_GET_INVOICES = "api/postpaid/getInvoicesDetailsByStatementId";
    static API_GET_EXTEND_DUEDATE_HISTORY = "api/postpaid/getExtendDueDateHistory";

    static API_SEARCH_PASSENGER = "api/booking/searchPassenger";
    static GET_PAYMENTS_SETTINGS = "api/booking/getPaymentsSettings";
    static API_GET_PAYMENTS_FOR_HOTEL_BOOKING="api/hotel_booking/getPaymentsSettings";
    static SELECT_PAYMENT = "api/booking/selectPayment";
    static API_SELECT_PAYMENT_FOR_HOTEL="api/hotel_booking/selectPayment";
    static GET_PAY_SETTINGS_FOR_TICKETING = "api/booking/getPaymentsSettingsForTicketing";
    static SELECT_PAYMENT_FOR_TICKETING = "api/booking/getPaymentFeeForTicketing";
    static API_CREATE_PAYMENT_FOR_TICKETING = "api/booking/createPaymentForTicketing";
    static API_GET_AGENT_REPORT = "api/report/getAgentReport";
    static API_GET_SYSTEM_REPORT = "api/report/getSystemReport";
    static GET_PAY_LIST_FOR_TOPUP = "api/recharge/getPaymentForTopup";
    static CALCULATE_PAYMENT_FOR_TOPUP = "api/recharge/calculatePaymentFeeForTopup";
    static API_PREPAID_AGENT_TOPUP = "api/agent/Topup";
    static GET_PAY_LIST_FOR_POSTPAID_TOPUP = "api/recharge/getPaymentForPostpaidPay";
    static CALCULATE_PAYMENT_FOR_POSTPAID_TOPUP = "api/recharge/calculatePaymentFeeForPostpaidPay";
    static API_POSTPAID_AGENT_TOPUP = "api/recharge/Deposit";
    static API_GET_RECHARGE_DETAILS = 'api/recharge/getRechargeDetails';
    static GET_MENU_COUNT = 'api/utils/getMenuCount';
    static GET_ALL_STATE_FOR_EDIT = "/api/tools/getAllStateForEdit";
    static CANCEL_BOOKING = "api/booking/cancelBooking";
    static API_GET_TOPUP_REPORT = "api/agent/getTopupReport";


    static GET_ID_TYPE = "idType";
    static PAX_TITLE = "paxTitle";
    static GET_USER_ROLES_AND_PERMISSIONS = "api/userManagement/getPermissions";
    static UPDATE_PERMISSIONS = "api/userManagement/updatePermissions";
    static BOOKING_ID = "bookingId";
    static REJECT_AGENT = "api/registration/rejectAgent";
    static APPROVE_AGENT = "api/registration/approveagent";
    static PENDING_AGENT = "api/registration/getPendingAgentRegistrations";
    static GET_MENUS = "api/utils/getMenus";
    //static GET_USER_LOGO_DET = "api/agent/getuserlogodetails";
    static RENEW_JWT = 'api/auth/renew';
    static ALL_PRICING_TIERS = 'api/pricing/getB2bTiers';
    static GET_PRICING_BY_TIERID = 'api/pricing/getAllB2bPricings';
    static GET_PRICING_BY_PRICINGID = 'api/pricing/getB2bPricing';
    static STATUS = 'status';
    static PRICING_STATUS = 'pricingStatus'
    static GET_PRICING_CLASSES = 'api/pricing/getClasses';
    static GET_PRICING_SECTORS = 'api/pricing/getSectors';
    static GET_PRICING_SECTORS_CLASSES  ='api/pricing/getSectorsAndClass'
    static GET_AIRLINE_LIST = 'api/utils/getAirlines';
    static CLONE_PRICING_TIER = 'api/pricing/cloneTier';
    static CLONE_SIMPLE_PRICING_TIER='api/pricing/cloneB2bPricingMarkup'
    static CREATE_PRICING = 'api/pricing/createB2bPricing';

    static UPDATE_PRICING = 'api/pricing/editB2bPricing'
    static CREATE_SIMPLE_PRICING ='api/pricing/createB2bPricingMarkup';
    static UPDATE_SIMPLE_PRICING ='api/pricing/updateB2bPricingMarkup' 
    static UPDATE_TIER = 'api/pricing/updateB2bTier';
    static UPDATE_TIER_STATUS = 'api/pricing/updateTierActiveStatus';
    static CLONE_PRICING = 'api/pricing/clonePricing';
    static DELETE_PRICING = 'api/pricing/deleteB2bPricing';
    static DELETE_PRICING_TIER = 'api/pricing/deleteB2bTier'
    static GET_ASSIGNED_TIERS = 'api/pricing/getAssignedTiers';
    static UPDATE_ASSIGNED_TIERS = 'api/pricing/updateAssignedTiers';
    static ASSIGN_TIERS = 'api/pricing/assignTiers';
    static CREATE_PRICING_TIER = 'api/pricing/addb2bTier';
    static CREATE_CREDIT_NOTE = 'api/agent/createCreditNote';
    static CREATE_DEBIT_NOTE = 'api/agent/createDebitNote';
    static GET_TOOLS_CLASSES = 'api/tools/getClasses';
    static ADD_AIRLINE_CLASS = 'api/tools/addAirlineClass';
    static GET_PAYMENT_LIST_AGT_APPROVAL = 'api/payment/getPaymentListAgentApproval';
    static GET_CREDIT_NOTE = 'api/agent/getCreditNote';
    static GET_DEBIT_NOTE = 'api/agent/getDebitNote';
    static SEARCH_RESERVATION = 'api/agent/searchReservationByB2B';
    static CREATE_BOOKING = 'api/booking/createBooking';
    static CREATE_BOOKING_FOR_HOTEL = 'api/hotel_booking/createBooking';

    static GET_ORDER_DETAILS = 'api/booking/getOrderDetails';
    static GET_ORDER_DETAILS_SIGNEDIN = 'api/booking/getOrderDetails_signedIn';
    static MANAGE_ALL_AGENTS = 'api/agent/manageAllAgents';
    static ACTIVATE_AGENT = 'api/agent/activateAgent';
    static EDIT_AGENT = 'api/agent/editAgent';
    static GET_ALL_PAYMENTS = "api/payment/getAllPaymentSettings";
    static GET_PAYMENT_GROUP = "api/payment/getPaymentGroup";
    static GET_PAYMENT_PROVIDER = "api/payment/getPaymentProvider";
    static GET_ALL_PAYMENT_TYPES = "api/payment/getPaymentType";
    static GET_PAYMENT_TYPES = "api/payment/getPaymentTypeForEdit";
    static GET_PAYMENT_FEE = 'api/payment/getPaymentFee';
    static UPDATE_PAYMENT_FEE = 'api/payment/updatePaymentFee';
    static SWAP_PAYMENT_SETT = 'api/payment/swapPaymentSettings';
    static GET_STATEMENT_LIST = 'api/postpaid/getStatementList';
    static GET_POSTPAID_REPORT = 'api/report/getPostpaidReport';
    static GET_PREPAID_REPORT = 'api/report/getPrepaidReport';
    static GET_PREPAID_REPORT_SUMMARY = 'api/report/getPrepaidReportSummery';
    static GET_POSTPAID_REPORT_SUMMARY = 'api/report/getPostpaidReportSummery';
    static GET_PREPAID_TOPUP_FORECAST_REPORT = 'api/report/getPrepaidBookingTopupForecastReports';
    static GET_POSTPAID_TOPUP_FORECAST_REPORT = 'api/report/getPostpaidBookingTopupForecastReports';
    static API_PREPAID_TOPUP_PROJECTION_REPORT = 'api/report/getPrepaidBookingTopupProjectionReports';  
    static API_POSTPAID_TOPUP_PROJECTION_REPORT = 'api/report/getPostpaidBookingTopupProjectionReports';  
    static API_GET_CREDIT_SALE_REPORT_SUMMARY = 'api/report/geCreditSaleReportSummery'

    static API_GET_PROVIDERS = 'api/report/getProviders';
    static API_SYSTEM_TOPUP_FORECAST_REPORT='api/report/getSystemBookingTopupForecastReports';
    static API_PERIODICAL_SALES_REPORT='api/report/getSystemPeriodicalSalesSummaryReports';
    static API_PERIODICAL_SALES_DETAIL_REPORT='api/report/getPeriodicalSalesDetailReport';
    static GET_PAYMENT_LIST_AGT_MANAGE = 'api/payment/getPaymentListAgentmanagent';
    static GET_TICKETING_QUEUE = 'api/booking/getTicketingQueueList';
    static EXTEND_DUE_DATE = 'api/postpaid/extendDueDate';
    static POSTPAID_DEPOSIT = 'api/postpaid/deposit';
    static GET_MY_BOOKINGS = 'api/booking/getMyBookingsList';
    static GET_POSTPAID_DET_BY_INVOICE = 'api/postpaid/getPaidDetailsByInvoiceId';
    static GET_POSTPAID_INVOICE_BY_STMNT_ID = 'api/postpaid/getInvoicesByStatementId';
    static FORGOT_PASSWORD = 'api/userManagement/forgotPassword';
    static RESET_PASSWORD = 'api/userManagement/resetPassword';
    static BALANCE_DETAIL = 'api/agent/getBalanceDetails';
    static GET_SETTINGS = 'api/utils/getSettings';
    static GET_ROUTES_FOR_EDIT = 'api/tools/getRoutesForEdit';
    static MANAGE_ROUTES = 'api/tools/manageRoutes';
    static CREATE_ROUTE = 'api/tools/createRoute';
    static CREATE_AIRPORT = 'api/tools/createAirport';
    static EDIT_AIRPORT = 'api/tools/editAirport';

    static GET_PAYMENT_PROVIDER_FOR_CREATE = 'api/payment/getPaymentProviderForCreate'
    static GET_AIRPORT = 'api/tools/getAirports';
    static GET_ORDER_DETAILS_VIEW = 'api/booking/getOrderDetailsForView';
    static GET_ORDER_DETAILS_VIEW_NEW = 'api/booking/getOrderDetailsForView_new';
    static API_GET_AIRPORTS_BY_COUNTRY_CODE = 'api/b2b/crs/getAirportsByCountryCode';
    static API_GET_TAX_SETUP_BY_COUNTRY = 'api/b2b/crs/getTaxSetupByCountry';

    static GET_ALL_CONTRACT = 'api/b2b/crs/getAllContract';
    static CREATE_CONTRACT = 'api/b2b/crs/createContract';
    static GET_ALL_AIRLINES = 'api/b2b/crs/getAllAirlines';
    static GET_CRS_PROVIDERS = 'api/b2b/crs/getCrsProviders';
    static UPDATE_CONTRACT = 'api/b2b/crs/updateContract';
    static DELETE_CONTRACT = 'api/b2b/crs/deleteContract';
    static CRS_GET_FARE_RULE =  'api/b2b/crs/getFareRule';
    static CRS_FARE_VIEW = 'api/b2b/crs/fareView';

    static API_ALL_ORG='api/orgManagement/getAllOrganization'
    static API_ORG_MODULES='api/orgManagement/getAllOrgProjectsWithModule'
    static API_UPDATE_ALL_ORG_MODULES='api/orgManagement/updateAllOrgProjectsWithModule'


    //Refund Flow
    static API_DET_FOR_REFUND ='api/refund/GetBookingDetails_modification';
    static API_INITIATE_REFUND='api/refund/manual_refund_initiate';
    static API_REFUND_LIST="api/refund/getRefundRequestedList";
    static API_REFUND_REQUESTED="api/refund/getRefundRequestedDetails"
    static  API_REFUND_HOLD="api/refund/manual_refund_hold"
    static  API_REFUND_DECLINE="api/refund/manual_refund_decline"
    static  API_REFUND_FULLFILL="api/refund/manual_refund_fulfill"


    //Exchange Flow
    static API_DET_FOR_EXCHANGE ='api/exchange/GetBookingDetails_modification';
    static API_INITIATE_EXCHANGE='api/exchange/manual_exchange_initiate';
    static API_EXCHANGE_LIST="api/exchange/getExchangeRequestedList";
    static API_EXCHANGE_REQUESTED="api/exchange/getExchangeRequestedDetails"
    static  API_EXCHANGE_HOLD="api/exchange/manual_exchange_hold"
    static  API_EXCHANGE_DECLINE="api/exchange/manual_exchange_decline"
    static  API_EXCHANGE_FULLFILL="api/exchange/manual_exchange_fulfill"

    //Agent Group
    static CREATE_AGENT_GROUP = 'api/B2bGroup/createB2bGroup';
    static GET_B2B_GROUP_LIST_WITH_B2B = 'api/B2bGroup/getB2bGroupListWithB2b';
    static UPDATE_B2B_GROUP = 'api/B2bGroup/updateB2bGroup';
    static DELETE_B2B_CONTRACT = 'api/B2bGroup/deleteB2bGroup'  
    static GET_B2B_GROUP_LIST = 'api/B2bGroup/getB2bGroupList';

    ///system ticket now
    static GET_AGENT_USER_BY_ORDER_ID = 'api/ticket_verification/getAgentUsersByOrderId';
    static SEND_VERIFICATION_CODE = 'api/ticket_verification/sendVerificationCode';
    static VERIFY_CODE = 'api/ticket_verification/verifyCode';
    static ISSUED_VERIFIED_ORDER_TICKET = 'api/ticket_verification/issueVerifiedOrderTicket';

    static CREATE_CUSTOMER_PROFILE = 'api/sub_agent/create_customerprofile';
    static GET_ALL_SUB_AGENT = 'api/sub_agent/getAllSubAgent';
    static GET_SUB_AGENT_PAYMENT = 'api/sub_agent/paySubagentPayment';
    static EDIT_SUB_AGENT = 'api/sub_agent/editCustomerProfile';

    static GET_CITIES_FOR_HOTEL_BOOKING = 'api/hotel_booking/getCities';
    static HOTEL_SEARCH_RESULTS = 'api/hotel_booking/hotelSearch';
    static APT_ROOM_SEARCH = 'api/hotel_booking/roomSearch'
    static API_PRICING_ROOM = "api/hotel_booking/pricingRoom";

    static GET_NOTIFICATION_SETTINGS = 'api/notificationSetting/getSettings';
    static NOTIFICATION_UPDATE_EMAIL = 'api/notificationSetting/updateEmail';
    static NOTICATION_UPDATE_ACTIVATION = 'api/notificationSetting/act_deactivateEmail';
//hms
    static API_GET_SUPPLIER_GROUP = 'api/hms/getSupplierGroup';
    static API_DELETE_SUPPLIER_GROUP = 'api/hms/deleteSupplierGroup';
    static API_CREATE_SUPPLIER_GROUP = 'api/hms/createSupplierGroup';
    static API_UPDATE_SUPPLIER_GROUP = 'api/hms/updateSupplierGroup';

    static  API_GET_ALL_HOTELS = 'api/hms/getAllHotel';
    static  API_GET_HOTEL_GUEST_AGE_SETUP='api/hms/getHotelGustAgeSetup';
    static  API_UPDATE_HOTEL_GUEST_AGE_SETUP='api/hms/updateHotelGustAgeSetup';
    static  API_GET_HOTEL_BOOK_ALERT='api/hms/getHotelBookingAlert'
    static  API_UPDATE_HOTEL_BOOK_ALERT= 'api/hms/updateHotelBookingAlert'
    static  API_UPDATE_HOTEL_AMENITIES='api/hms/updateHotelAmenities'
    static  API_GET_HOTEL_AMENITIES='api/hms/getHotelAmenities'
   static   API_GET_HOTEL_SPORTS_ENTERN='api/hms/getHotelSportsEntertainments'
   static   API_UPDATE_HOTEL_SPORTS_ENTERN='api/hms/updateSportsEntertainments'
   static   API_GET_HOTEL_LANG='api/hms/getHotelLanguages'
   static  API_UPDATE_HOTEL_LANG='api/hms/updateHotelLanguages'

   static API_GET_ROOM_TYPES='api/hms/getRoomTypes'
   static API_GET_BED_TYPES='api/hms/getBedTypes'
   static API_GET_ALL_HOTEL_AMENITIES='api/hms/getAllHotelAmenities'

   static API_GET_HOTEL_TARIFF='api/hms/getHotelTariff';
   static API_GET_RATE_PLAN='api/hms/getRatePlan';
   static API_GET_HOTEL_CANCEL_POLICY='api/hms/getHotelCancellationPolicies'
   static API_CREATE_HOTEL_CANCELLATION_POLICY='api/hms/createHotelCancellationPolicies'
   static API_UPDATE_CANCELLATION_POLICY ='api/hms/updateHotelCancellationPolicies';
   static API_DELETE_CANCELLATION_POLICY = 'api/hms/deleteHotelCancellationPolicies';
   static API_GET_HOTEL_ROOMS='api/hms/getHotelRooms'
   static API_UPDATE_HOTEL_ROOM='api/hms/updateHotelRoom'
   static API_CREATE_HOTEL_ROOM='api/hms/createHotelRoom'
   static API_HMS_GET_ALL_LANG='api/hms/getAllLanguages'
   static API_CREATE_HOTEL_TARIFF='api/hms/createHotelTariff'
   static API_UPDATE_HOTEL_TARIFF='api/hms/updateHotelTariff'
   static API_DELETE_HOTEL_TARIFF = "api/hms/deleteHotelTariff";

   
 
    static API_GET_HOTEL_HELPFUL_FACTS='api/hms/getHotelHelpfulFacts'
    static API_UPDATE_HELPFUL_FACTS= 'api/hms/updateHotelHelpfulFacts';
    static API_GET_HOTEL_LOCATION= 'api/hms/getHotelLocation';
    static API_UPDATE_HOTEL_LOCATION='api/hms/updateHotelLocation';
    static API_CREATE_RATE_PLAN='api/hms/createRatePlan'
    static API_UPDATE_RATE_PLAN='api/hms/updateRatePlan'
    static API_UPDATE_RATE_PLAN_STATUS ='/api/hms/updateRatePlanStatus'
    static API_GET_HOTEL_IMAGES = 'api/hms/getHotelImages';
    static API_UPDATE_HOTEL_IMAGES = 'api/hms/UploadHotelImages';
    static API_DELETE_HOTEL_IMAGES='api/hms/deleteHotelImage';
    static API_GET_CHANNEL_MANAGER_LS = 'api/hms/getChannelManagerlist';
    static API_GET_HOTEL_CHANNEL_MANAGER = 'api/hms/getHotelChannelManager';
    static API_UPDATE_CHANNEL_MANAGER = 'api/hms/updateHotelChannelManager';
    static API_CREATE_SURCHARGE='api/hms/createHotelSurChargePolicies'
    static API_GET_SURCHARGES='api/hms/getHotelSurChargePolicies'
    static API_UPDATE_SURCHARGE='api/hms/updateHotelSurChargePolicies'
   static API_CLONE_RATE_PLAN ='api/hms/cloneRatePlan'
    static API_GET_HOTEL_MULTILANGUAGE = 'api/hms/getHotelMl';
    static API_UPDATE_HOTEL_MULTILANGUAGE = 'api/hms/updateHotelMl';

    static API_GET_ROOM_MULTILANGUAGE = 'api/hms/getHotelRoomsMl';
    static API_UPDATE_ROOM_MULTILANGUAGE = 'api/hms/updateHotelRoomsMl';

    static API_GET_HOTEL_INFO = 'api/hms/getHotelInfo';
    static API_GET_HOTEL_ROOM_INFO = 'api/hms/getHotelRoomInfo';

    static API_GET_RATEPLAN_MULTILANGUAGE = 'api/hms/getHotelRatePlanMl';
    static API_UPDATE_RATEPLAN_MULTILANGUAGE = 'api/hms/updateHotelRatePlanMl';
    static API_CREATE_HOTEL_TAX=  '/api/hms/hotel/createHotelTaxSetup'
    static API_HMS_COUNTRY_TAX='api/hms/createHotelTaxSetup'
    static API_UPDATE_HOTEL_TAX='api/hms/updateHotelTaxSetup'
    static API_GET_HOTEL_TAX='api/hms/getHotelTaxSetup'
   static API_DELETE_HOTEL_TAX='api/hms/deleteHotelTaxSetup'

   static API_GET_HOTEL_MARKUP = 'api/hms/getHotelMarkup';
   static API_CREATE_HOTEL_MARKUP = 'api/hms/createHotelMarkup';
   static API_UPDATE_HOTEL_MARKUP = 'api/hms/updateHotelMarkup';
   static API_DELETE_HOTEL_MARKUP = 'api/hms/deleteHotelMarkup';
   static API_DELETE_HOTEL_ROOM='api/hms/deleteHotelRoom'
   static API_DELETE_SURCHARGE='api/hms/deleteHotelSurChargePolicies'
   static API_GET_HOTEL_ERRORS='api/hms/getHotelErrors'
   static API_GET_RATE_PLAN_INFO='api/hms/getRatePlanInfo'

   ///crs report
   static API_BOOKING_MANIFEST_REPORT = 'api/b2b/crs/getBookingManiFestReport';
   static API_BOOKING_LIST_REPORT = 'api/b2b/crs/getBookingListReport';
   static API_FLIGHT_LOAD_FACTOR_REPORT = 'api/b2b/crs/getFlightLoadFactorReport';
   static API_CRS_FLIGHT_TIME_WITH_ROUTE = 'api/b2b/crs/getFlightTimingWithRoute';
   static API_UNIQ_FLIGHT_NUM_WITH_ROUTE ='api/b2b/crs/getUniqFlightNumbersWithRoute';

   
   static API_GET_HOTEL_AVAILABILITY='api/hms/GetHotelAvailability';
   static API_CREATE_HOTEL_TARIFF_OVERRIDE = 'api/hms/createHotelTariffOverRide';
   static API_UPDATE_HOTEL_TARIFF_OVERRIDE = 'api/hms/updateHotelTariffOverRide';
   static API_GET_HOTEL_TARIFF_OVERRIDE = 'api/hms/getHotelTariffOverRide';
   static API_GET_HOTEL_TARIFF_BY_ID = 'api/hms/getHotelTariffById'


   static API_DELETE_SIMPLE_PRICING='api/pricing/deleteB2bPricingMarkup'
   static API_GET_SIMPLE_PRICING='api/pricing/getB2bPricingMarkup'
}

export class HTTP_CODES {
    static SUCCESS = 200;
    static ERROR = 400;

    static SUCCESS_STR = "Success";
    static ERROR_STR = "Error";
    static ERROR_JWT = "jwt";
    static ERROR_JWT_01 = "JWT01";
    static ERROR_JWT_02 = "JWT02";
    static ERROR_NET = "Connectivity";

    static ERROR_PRIC_FLI_FAILED = "SES08";
    static ERROR_FLI_INVALID = "SES09";


    static ERROR_SESSION_NOT_EXIST = "SES03";
    static ERROR_PER = "PER01";
    static ERROR_AUT2 = "AUT2";

    static SUBSCRIPTION_FAILED = "start-failed";

    static ERROR_INVOICES_PAID="PST03";



}

export class LOG_TYPE {
    static INFO = 'info';
    static ERROR = "error";
    static CRITICAL = "critical";
    static WARNING = "warning";
}

export class WEBSOCKET_READYSTATE
{
    static CONNECTING = 0;//Socket has been created. The connection is not yet open.
    static OPEN = 1; //The connection is open and ready to communicate.
    static CLOSING = 2; //The connection is in the process of closing.
    static CLOSED = 3; //The connection is closed or couldn't be opened.

}


/* export class DEFAULT_IMAGES {
    static CUS_RATING_DEF_IMG = "https://www.google.com";
} */

export class FILE_NAME {


    static API_DELETE_SIMPLE_PRICING='apiDeleteSimplePricing'
    static API_GET_SIMPLE_PRICING='apiGetSimplePricing'
    static CREATE_SIMPLE_PRICING ='CreateSimplePricing'
    static  API_CREATE_SIMPLE_PRICING='apiCreateSimplePricing'
    static  API_UPDATE_SIMPLE_PRICING ='apiUpdateSimplePricing'     
    static API_ORG_MODULES='apiAllOrgModules'
    static API_UPDATE_ALL_ORG_MODULES='apiUpdateAllOrgModules'
    static API_ALL_ORG='apiAllOrg'
    static API_HMS_COUNTRY_TAX='apiHmsCountryTax.js' 
    static MANAGE_ORG='ManageOrg'
    static ENV_CONFIG='env-config.js'
    static C_HOTEL_THUMBNAIL='cHotelThumbnail'
    static C_HOTEL_AVAILABILITY='cHotelAvailability'
    static C_WEEK_DAYS='cWeekDays'
    static API_GET_HOTEL_AVAILABILITY ='apiGetHotelAvail' 
    static C_AVAILABILITY='cAvailability'
    static C_SURCHARGE_SETUP='cSurchargeSetup'
    static C_HOTEL_ERRORS='cHotelErrors.vue'
    static API_GET_HOTEL_ERRORS='apiGetHotelErrors.js'
    static API_DELETE_SURCHARGE='apiDeleteSurcharge'
    static API_DELETE_HOTEL_ROOM='apiDeleteHotelRoom'
    static ALL_HOTEL_TAX_SETUP='AllHotelTaxSetup'
    static C_HOTEL_ROOM_NEW='cHotelRoomNew'
    static HOTEL_ROOM_SETUP='HotelRoomSetup'
    static  C_SWAP_MODAL_PAGE =  'cSwapModalPage'
    static C_HOTEL_TAX_SETUP='cHotelTaxSetup'
    static API_DELETE_HOTEL_TAX='apiDeleteHotelTax'
    static C_ALL_HOTEL_TAX='cAllHotelTax'
    static C_HOTEL_SURCHARGES='cHotelSurcharges' 
    static API_CREATE_SURCHARGE='apiCreateSurcharge';
    static API_UPDATE_SURCHARGE='apiUpdateSurcharge';
    static API_CREATE_HOTEL_CANCELLATION_POLICY='apiCreateHotelCancellationPolicy'
    static API_UPDATE_CANCELLATION_POLICY='apiUpdateCancelPolicy';
    static API_DELETE_CANCELLATION_POLICY = 'apiDeleteCancelPolicies';
    static API_CREATE_RATE_PLAN='apiCreateRatePlan'
    static C_ROOM_RATE_PLANS='cRoomRatePlans'
    static C_ROOM_TYPE_INFO='cRoomTypeInfo'
    static API_GET_SURCHARGES='apiGetSurcharges';
    static API_GET_HOTEL_MULTILANGUAGE = 'apiGetHotelMl';
    static API_UPDATE_HOTEL_MULTILANGUAGE = 'apiUpdateHotelMl'
    static API_GET_ROOM_MULTILANGUAGE = 'apiGetRoomMl';
    static API_UPDATE_ROOM_MULTILANGUAGE = 'apiUpdateRoomMl';
    static API_GET_RATEPLAN_MULTILANGUAGE = 'apiGetHotelRatePlanMl';
    static API_UPDATE_RATEPLAN_MULTILANGUAGE = 'apiUpdateHotelRatePlanMl';
   static API_CREATE_HOTEL_TAX='apiCreateHotelTax.js'
   static API_UPDATE_HOTEL_TAX='apiUpdateHotelTax.js'
   static API_GET_HOTEL_TAX='apiGetHotelTax.js'

    static API_GET_HOTEL_INFO = 'apiGetHotelInfo';
    static API_GET_HOTEL_ROOM_INFO = 'apiGetHotelRoomInfo';

    static TARIFF_NEW = 'TariffNew'
    static RATE_PLAN_NEW  = 'RatePlanNew'
    static CANCELLATION_NEW  = 'CancellationNew'
    static SURCHARGE_NEW  = 'SurchargeNew'


    static TARIFF_ALL = 'TariffAll'
    static RATE_PLAN_ALL = 'RatePlanAll'
    static CANCELLATION_ALL = 'CancellationAll'
    static SURCHARGE_ALL = 'SurchargeAll'

    static API_GET_HOTEL_TARIFF='apiGetHotelTariff';
    static API_GET_RATE_PLAN='apiGetRatePlan';
    static API_GET_HOTEL_CANCEL_POLICY='apiGetHotelCancelPolicy'

    static API_GET_HOTEL_MARKUP = 'apiGetHotelMarkup';
    static API_CREATE_HOTEL_MARKUP = 'apiCreateHotelMarkup';
    static API_UPDATE_HOTEL_MARKUP = 'apiUpdateHotelMarkup';
    static API_DELETE_HOTEL_MARKUP = 'apiDeleteHotelMarkup';

    static C_ROOM_LANG='cRoomLang'  
    static API_UPDATE_RATE_PLAN='apiUpdateRatePlan.js'
    static API_CLONE_RATE_PLAN ='apiCloneRatePlan.js'
    static API_UPDATE_RATE_PLAN_STATUS='apiUpdateRatePlanStatus.js'
    static API_GET_ROOM_TYPES='apiGetRoomTypes.js'
    static API_GET_BED_TYPES='apiGetBedTypes.js'
    static API_GET_ALL_HOTEL_AMENITIES='apiGetAllHotelAmenities'
    static API_GET_HOTEL_ROOMS='apiGetHotelRooms.js'
    static API_HMS_GET_ALL_LANG='apiHmsGetAllLang.js'
    static API_CREATE_HOTEL_TARIFF='apiCreateHotelTariff.js'
    static API_UPDATE_HOTEL_TARIFF='apiUpdateHotelTariff.js'
    static API_DELETE_HOTEL_TARIFF = "apiDeleteHotelTariff.js";

    static API_CREATE_HOTEL_TARIFF_OVERRIDE = "apiCreateHotelTariffOverride"
    static API_UPDATE_HOTEL_TARIFF_OVERRIDE = "apiUpdateHotelTariffOverride"
    static API_GET_HOTEL_TARIFF_OVERRIDE = 'apiGetHotelTariffOverRide'
    static API_GET_HOTEL_TARIFF_BY_ID= 'apiGetHotelTariffById';

    static API_UPDATE_HOTEL_ROOM='apiUpdateHotelRoom.js'
    static API_CREATE_HOTEL_ROOM='apiCreateHotelRoom.js'
    static C_BED_TYPES='cBedTypes'  
    static C_ROOM_AMENITIES='cRoomAmenities'
    static C_HOTEL_ROOM_DET='cHotelRoomDet'
    static C_HOTEL_LANG='cHotelLang.vue'
    static API_GET_HOTEL_LANG='apiGetHotelLang.js'
    static API_UPDATE_HOTEL_LANG='apiUpdateHotelLang.js'
    static API_GET_HOTEL_SPORTS_ENTERN='apiGetHotelSportsEntern.js'
    static API_UPDATE_HOTEL_SPORTS_ENTERN='apiUpdateHotelSportsEntern.js'
    static C_HOTEL_AMENITIES='cHotelAmenities'
    static  API_UPDATE_HOTEL_AMENITIES='apiUpdateHotelAmenities'
    static API_GET_HOTEL_AMENITIES='apiGetHotelAmenities'
    static C_ALERT_SETUP='cAlertSetup'
    static C_AGE_SETUP='cAgeSetup'   
    static API_GET_HOTEL_GUEST_AGE_SETUP='apiHotelGuestAgeSetup';
    static API_UPDATE_HOTEL_GUEST_AGE_SETUP='apiUpdateHotelGuestAgeSetup'    
    static C_CONTENT_EDIT='cContentEdit';
    static HOTEL_INFO='HotelInfo.vue'
    static BOOKING_DETAILS='BookingDetails.vue'
    static C_EXPORT_EXCEL='cExportExcel.vue'
    static C_SPORTS_ENTERN='cSportsEntern.vue'
    static API_REFUND_REQUESTED='apiRefundRequested.js';
    static API_DET_FOR_REFUND='apiDetForRefund.js';
    static API_REFUND_INITIATE='apiRefundInitiate.js';
    static API_REFUND_HOLD='apiRefundHold.js'
    static API_REFUND_FULL_FILL='apiRefundFullFill.js'
    static API_REFUND_DECLINE='apiRefundDecline.js' 
    static  API_REFUND_LIST ='apiRefundList.js'
    static API_GET_HOTEL_BOOK_ALERT='apiGetHotelBookAlert.js'
    static API_UPDATE_HOTEL_BOOK_ALERT='apiUpdateHotelBookAlert.js'
    static API_GET_HOTEL_HELPFUL_FACTS = 'apiGetHotelHelpfulFacts.js'
    static API_UPDATE_HELPFUL_FACTS = 'apiUpdateHelpfulFacts';
    static API_GET_HOTEL_LOCATON = 'apiGetHotelLocation';
    static API_UPDATE_HOTEL_LOCATION = 'apiUpdateHotelLocation'
    static API_GET_HOTEL_IMAGES = 'apiGetHotelImages';
    static API_UPDATE_HOTEL_IMAGES= 'apiUpdateHotelImages';
    static API_DELETE_HOTEL_IMAGES='apiDeleteHotelImages';
    static API_GET_CHANNEL_MANAGER_LS= 'apiGetChannelManagerLs';
    static API_GET_HOTEL_CHANNEL_MANAGER = 'apiGetHotelChannelManager';
    static API_UPDATE_CHANNEL_MANAGER = 'apiUpdateChannelManager'
    static API_GET_HMS_ALL_EMUMS = "apiGetHmsAllEnums";
    static API_GET_CRS_ALL_EMUMS = "apiGetCrsAllEnums";
    static API_GET_HMS_USER_PERMISSION = "apiGetHmsUserPermission";
    static API_GET_HOTEL_ROOM_IMAGE = 'apiGetHotelRoomImage';
    static API_UPDATE_HOTEL_ROOM_IMAGE = 'apiUpdateHotelRoomImage';
    static API_DELETE_HOTEL_ROOM_IMAGE = 'apiDeleteHotelRoomImage';

    static API_EXCHANGE_REQUESTED='apiExchangeRequested.js';
    static API_DET_FOR_EXCHANGE='apiDetForExchange.js';
    static API_EXCHANGE_INITIATE='apiExchangeInitiate.js';
    static API_EXCHANGE_HOLD='apiExchangeHold.js'
    static API_EXCHANGE_FULL_FILL='apiExchangeFullFill.js'
    static API_EXCHANGE_DECLINE='apiExchangeDecline.js' 
    static  API_EXCHANGE_LIST ='apiExchangeList.js'
    static API_GET_RATE_PLAN_INFO='apiGetRatePlanInfo.js';

    ///crs report
   static API_BOOKING_MANIFEST_REPORT = 'apiBookingManiFestReport';
   static API_BOOKING_LIST_REPORT = 'apiBookingListReport';
   static API_FLIGHT_LOAD_FACTOR_REPORT = 'apiFlightLoadFactorReport';
   static API_CRS_FLIGHT_TIME_WITH_ROUTE = 'apiCrsFlightTimingwithRoute';
   static API_UNIQ_FLIGHT_NUM_WITH_ROUTE = 'apiCrsFlightNumwithRoute';


    static SYSTEM_REPORT ='SystemReport.vue'
    static EXCHANGE ='Exchange.vue'
    static ALL_REFUND ='AllRefund.vue'
    static REFUND_DET ="RefundDet.vue"
    static C_EDIT_TICKETS='cEditTickets.vue'

    static C_EDIT_PASSN='cEditPassn.vue'
    static  C_EDIT_FLIGHT ='cEditFlight.vue'

    static REFUND ='Refund.vue';
    static API_DELETE_TAX_SETUP ='apiDeleteTaxSetup';
    static API_DELETE_STATE = 'apiDeleteState.js';
    static API_EDIT_STATE = 'apiEditState.js';
    static API_ADD_COUNTRY = 'apiAddCountry.js';
    static API_ADD_ORG_CURRENCY = 'apiAddOrgCountry.js';
    static EDIT_ORG_CURRENCY = "apiEditOrgCurrency";
    static API_ADD_STATE = 'apiAddState.js';
    static API_UPDATE_EXTENSION_SETUP ='apiUpdateExtensionSetUp.js';
    static API_GET_EXTENSION_SETUP = 'apiGetExtensionSetUp.js';
    static API_B2B_SYS_BOOKING_NUMBER = 'apib2bSysBookingNo.js';
    static API_B2B_SYS_SEARCH_COUNT = 'apib2bSysSearchCount.js';
    static API_B2B_SYS_WEEKLY_SALES = 'apib2bSysWeeklySales.js';
    static API_GET_SYS_BOOKING_NUMBER = 'apiGetSysBookingNumber.js';
    static API_GET_USER_LOGIN_ACTIVITY = 'apiGetUserLoginActvty.js';
    static API_GET_SEARCH_COUNT = 'apiSearchCount.js';
    static API_GET_WEEKLY_SALES = 'apiWeeklySales.js';
    static API_GET_AGENT_SALES = 'apiAgentSales.js';
    static API_GET_DAY_TO_DAY_SALES = 'apiGetDayToDaySales.js';
    static API_GET_MINI_BOOKING_LS = 'apiGetMiniBookingLs.js';
    static API_GET_BOOKING_NUMBER = 'apiGetBookingNumber.js';
    static API_GET_MINITCKT_QUEUE = 'apiGetMiniTcktqueueLs.js';
    static C_ML_TOTAL_PRICE_INFO = 'cMLTotalPriceInfo.vue';
    static C_ML_PER_PAX_PRICE_INFO = 'cMLPerPaxPriceInfo.vue'
    static C_STATUS_BUTTON = 'cStatusButton.vue'
    static DASHBOARD = 'DashBoard.vue'
    static CLEAR_STORE = 'clearStore.js '
    static C_AGENT_DEPOSIT = 'cAgentDeposit.vue'
    static C_SYSTEM_DEPOSIT = 'cSystemDeposit.vue'
    static AGENT_DEPOSIT = 'agentDeposit.vue'
    static MANAGE = 'Manage.vue'
    static API_POSTPAID_PAYMENT_HIS = 'apiPostPaidPaymentHistory.js'
    static API_POSTPAID_TRANSACTIONS = 'apiPostPaidTransactions.js'
    static API_POSTPAID_DEPOSIT = 'apiPostPaidDeposit.js'
    static API_POSTPAID_EXTEND_DUE_DATE = 'apiPostPaidExtendDueDate.js'
    static DEPOSIT = 'Deposit.vue'
    static API_GET_POSTPAID_STATEMENT_LIST = 'apiGetPostpaidStatementList.js'
    static API_GET_POSTPAID_REPORT = 'apiGetPostpaidReport.js'
    static API_GET_PREPAID_REPORT = 'apiGetPrepaidReport.js'
    static API_GET_PREPAID_REPORT_SUMMARY = 'apiGetPrepaidReportSummary.js'
    static API_GET_PREPAID_TOPUP_FORECAST_REPORT = 'apiGetPrepaidTopupForecastReport.js'
    static API_GET_POSTPAID_TOPUP_FORECAST_REPORT = 'apiGetPostpaidTopupForecastReport.js'
    static API_GET_PROVIDERS = 'apiGetProviders.js'
    static API_SYSTEM_TOPUP_FORECAST_REPORT = 'apiSystemTopupForecastReport.js'
    static API_GET_POSTPAID_REPORT_SUMMARY = 'apiGetPrepaidReportSummary.js'
    static API_PERIODICAL_SALES_REPORT = 'apiPeriodicalSalesReport.js'
    static API_PERIODICAL_SALES_DETAIL_REPORT = 'apiPeriodicalSalesDetailReport.js'
    static API_PREPAID_TOPUP_PROJECTION_REPORT = 'apiPrepaidTopupProjectionReport.js'
    static API_POSTPAID_TOPUP_PROJECTION_REPORT = 'apiPostpaidTopupProjectionReport';  
    static API_GET_CREDIT_SALE_REPORT_SUMMARY = 'apiGetCreditSaleReportSummary.js'

    static LOCAl_STORAGE = 'localStorage.js'
    static API_SWAP_PAYMENT_SETT = 'apiSwapPaymentSetting.js'
    static PAYMENT_FEE = 'PaymentFee.vue'
    static API_UPDATE_PAYMENT_FEE = 'apiUpdatePaymentFee.js'
    static API_GET_PAYMENT_FEE = 'apiGetPaymentFee.js'
    static API_GET_ALL_PAYMENT_TYPES = "apiGetAllPaymentTypes.js";
    static API_GET_PAYMENT_TYPES = "apiGetPaymentTypes.js"; ///payment types by paymentId
    static API_PAYMENT_GROUPS = "apiPaymentGroups.js";
    static API_PAYMENT_PROVIDERS = "apiPaymentProviders.js";
    static API_PAYMENT_PROVIDERS_FOR_CREATE = 'apiPaymentProviders.js'
    static API_CREATE_PAYMENT = "apiCreatePayment.js";
    static API_GET_INVOICES = "apiGetInvoices.js";
    static API_GET_EXTEND_DUEDATE_HISTORY = "apiGetExtendDueDateHistory.js";
    static API_GET_FLIGHT_SCHEDULE = "apiGetFlightSchedule.js";
    static API_GET_FLIGHT_SCHEDULE_ROUTES = "apiGetFlightScheduleRoutes.js";
    static API_GET_TAX_SETUP = "apiGetTaxSetup.js";
    static API_GET_DELETE_FLIGHT_SCHEDULE = "apiDeleteFlightSchedule.js";
    static API_CHANGE_FLIGHT_SCHEDULE_STATUS = "apiChangeFlightScheduleStatus.js";
    static API_GET_FLIGHT_FARE = "apiGetFlightFare.js";
    static API_GET_FARE_RULE = "apiGetFareRule.js";
    static API_GET_DELETE_FLIGHT_FARE = "apiDeleteFlightFare.js";
    static API_CLONE_FARE_RULE = "apiCloneFareRule.js";
    static API_DELETE_FARE_RULE = "apiDeleteFareRule.js";

    static API_UPDATE_PAYMENT = "apiUpdatePayment.js";
    static ADD_PAYMENT = "AddPayment.vue";
    static API_GET_ALL_PAYMENTS = "apiGetAllPayments.js";
    static API_GET_PAYMENT_LIST_AGT_APPROVAL = "apiGetPaymentListAgtApproval.js";
    static API_GET_PAYMENT_SETTINGS = 'apiGetPaymentSettings.js'
    static API_GET_PAYMENTS_FOR_HOTEL_BOOKING = 'apiGetPaymentsForHotelBooking.js'

    static API_SELECT_PAYMENT = 'apiSelectPayment.js'
    static API_SELECT_PAYMENT_FOR_HOTEL = 'apiSelectPaymentForHotel.js'
    static APT_SEARCH_PASSENGER = 'apiSearchPassenger.js'
    static API_GET_PAY_SETTINGS_FOR_TICKETING = 'apiGetPaymentSettingsForTicketing.js'
    static API_SELECT_PAYMENT_FOR_TICKETING = 'apiSelectPaymentForTicketing.js'
    static API_CREATE_PAYMENT_FOR_TICKETING = "apiCreatePaymentForTicketing.js";
    static API_GET_AGENT_REPORT = "apiGetAgentReport.js";
    static API_GET_SYSTEM_REPORT = "apiGetSystemReport.js";
    static API_GET_PAY_LIST_FOR_TOPUP = 'apiGetPaymentListForTopUp.js'
    static API_CAL_PAY_FEE_FOR_TOPUP = 'apiCalculatePaymentFeeForTopUp.js'
    static API_CANCEL_BOOKING = 'apiCancelBooking.js'
    static API_GET_TOPUP_REPORT = "apiGetTopUpReport.js";
    static GET_ORG_CURRENCY = "apiGetOrgCurrencyLs.js";
    static API_GET_ADMIN_SIGNIN_STATUS = "apiAdminSignIn.js";
    static API_GET_ALL_AGENT = "apiGetAllAgent.js";

    static API_PREPAID_AGENT_TOPUP = 'apiPrepaidAgentTopUp.js'
    static API_GET_ORDER_DETAILS = 'apiGetOrderDetails.js'
    static API_GET_ORDER_DETAILS_SIGNEDIN = 'apiGetOrderSignedIn.js'
    static API_GET_PAY_LIST_FOR_POSTPAID_TOPUP = 'apiGetPaymentListForPostPaidTopUp.js'
    static API_CAL_PAY_FEE_FOR_POSTPAID_TOPUP = 'apiCalculatePaymentFeeForPostPaidTopUp.js'
    static API_POSTPAID_AGENT_TOPUP = 'apiPostpaidAgentTopUp.js'
    static API_RECHARGE_DETAILS = 'apiRechargeDetails.js'
    static API_GET_MENU_COUNT= 'apiGetMenuCount.js';
    static API_GET_ALL_STATE_FOR_EDIT = 'apiGetAllStateForEdit.js';
    static API_PRICING_SEARCH = "apiPricingSearch.js";
    static API_UPDATE_PRICING = "apiUpdatePricing.js";
    static API_CREATE_PRICING = "apiCreatePricing.js";
    static API_CREATE_PRICING_TIER = "apiCreatePricingTier.js";
    static API_DELETE_PRICING_TIER = "apiDeletePricingTier.js";
    static API_CLONE_PRICING_TIER = "apiClonePricingTier.js";
    static API_CLONE_SIMPLE_PRICING_TIER = "apiCloneSimplePricingTier.js";
    static API_GET_PRICING_SECTORS = "apiGetPricingSectors.js";
    static API_GET_PRICING_SECTORS_CLASSES = "apiGetPricingSectorsClasses.js";
    static API_GET_PRICING_CLASSES = "apiPricingClasses.js";
    static API_ALL_PRICING_TIERS = "apiAllPricingTiers.js";
    static API_GET_ROUTES = "apiGetRoutes";
    static ROUTES = "Routes.vue";
    static API_SYSTEM_TOPUP = "apiSystemTopUp";
    static API_SEARCH_RESULT = "apiSearchResult";
    static API_SEARCH_WITHOUT_MARKUP = "apiSearchWithoutMarkup";

    static API_UPDATE_PERMISSIONS = "apiUpdatePermissions.js";
    static API_ROLES_PERMISSIONS = "apiRolesPermissions.js";
    static ROLES_PERMISSIONS = "RolesPermissions.vue";
    static AGENT_REGISTRATION = "AgentRegistration.vue";
    static AGENT_LOGIN = "AgentLogin.vue";
    static SYSTEM_LOGIN = "SystemLogin.vue";
    static APPROVE_AGENT = "ApproveAgent.vue";
    static API_GET_ALL_AGENTS = "apiGetAllAgent.js";
    static API_CREATE_AGENT = "apiCreateAgent.js";
    static API_GET_AGENT_DETAILS = "apiGetAgentDetails.js";
    static API_GET_CAPTCHA_LIST = "apiGetCaptchaList.js";
    static API_GET_COUNTRY_LIST = "apiGetCounryList.js";
    static API_GET_CURRENCY_LIST = "apiGetCurrencyLs.js";
    static API_GET_CURRENCY_FOR_EDIT = "apiGetCurrencyForEdit.js";
    static API_GET_STATE_LIST = "apiGetStateList.js";
    static API_GET_MENUS = "apiGetMenus.js";
    static API_SIGN_IN = "apiSignIn.js";
    static API_ADMIN_SIGN_IN = "apiAdminSignIn.js";
    static ADD_USER = "AddUser.vue";
    static USER_STATUS = "UserStatus.vue";
    static API_CREATE_USER = "apiCreateUser.js";
    static MANAGE_USERS = "ManageUsers.vue";
    static SETUP_PRICING = "SetupPricing.vue";
    static CREATE_PRICING = "CreatePricing.vue";
    static EXCHANGE_RATE = "ExchangeRate.vue";
    static CREDIT = "Credit.vue";
    static CREDIT_REPORT = "CreditReport.vue";
    static DEBIT_NOTE = "DebitNote.vue";
    static SEARCHPAGE = "SearchPage.vue";
    static CHANGE_PRICING = "ChangePricing";
    static MANAGE_PRICING = "ManagePricing.vue";
    static API_EXCHANGE_RATE = "apiExchangeRateDetails.js";
    static API_GET_LANGUAGE_LIST = "apiLanguageList.js";
    static API_LOG_OUT = "apiLogOut.js";

    static API_SAVE_EXCHANGE_RATE = "apiSaveExchangeRate.js";
    static API_GET_All_USER = "apiGetAllUser.js";
    static API_UPDATE_USER = "apiUpdateUser.js";
    static API_USER_ROLES = "apiUserRoles.js";
    static API_VALIDATE_TOKEN = "apiValidateToken.js";

    static API_CHANGE_PASSWORD = "apiChangePassword.js";
    static CHANGE_PASSWORD = "ChangePassword.vue";
    static cDropDown = "cDropDown.vue";
    static C_LANGUAGE_PICKER = "cLanguagePicker.vue";
    static DATE_FUNCTIONS = "dateFunctions.js";
    static LOGGER = "logger.js";
    static HTTP_POST = "httppost.js";
    static SIDE_BAR = "TheSidebar.vue";
    static APP = "app.vue";
    static TOPUP = "TopUp.vue";
    static SYSTEM_TOPUP = "SystemTopUp.vue";
    static ROUTE = "Route.vue";
    // static API_USER_LOGO_DET = "apiUserLogoDet.js";
    static THE_HEADER_DROPDOWN_ACCNT = "TheHeaderDropdownAccnt.vue";
    static UTIL = "util.js";
    static API_RENEW_JWT = "apiRenewJWT.js";
    static ROUTER = "router/index.js";
    static API_GET_PRICING_BY_TIERID = "apiGetPricingByTierId.js";
    static API_GET_PRICING_BY_PRICINGID = "apiGetPricingByPricingId.js";
    static API_GET_AIRLINE = "apiGetAirline.js";
    static API_GET_ALL_AIRLINES = "apiGetAllAirlines.js";
    static API_CREATE_FLIGHT_SCHEDULE = "apiCreateFlightSchedule.js";
    static API_UPDATE_FLIGHT_SCHEDULE = "apiUpdateFlightSchedule.js";
    static API_CREATE_FLIGHT_FARE = "apiCreateFlightFare.js";
    static API_CREATE_FARE_RULE = "apiCreateFareRule.js";
    static API_CREATE_TAX_SETUP = "apiCreateTaxSetup.js";
    static API_UPDATE_TAX_SETUP = "apiUpdateTaxSetup.js";
    static API_CREATE_HOTEL = "apiCreateHotel.js";
    static API_UPDATE_HOTEL = "apiUpdateHotel.js";
    static API_DELETE_HOTEL = "apiDeleteHotel.js";
    static API_CREATE_HMS_USER = "apiCreateHmsUser.js";
    static API_GET_ALL_HMS_USERS = 'apiGetAllHmsUsers.js';
    static API_UPDATE_HMS_USER = "apiUpdateHmsUser.js";

    static API_UPDATE_FARE_RULE = "apiUpdateFareRule.js";
    static API_UPDATE_FLIGHT_FARE = "apiUpdateFlightFare.js";
    static API_IMPORT_VALIDATION_FLIGHT_FARE = "apiImportValidationFlightFare.js";
    static API_IMPORT_FLIGHT_FARE = "apiImportFlightFare.js";

    static API_UPDATE_TIER = "apiUpdateTier.js";
    static API_UPDATE_TIER_STATUS = "apiUpdateTierStatus.js";
    static API_CLONE_PRICING = "apiClonePricing";
    static API_DELETE_PRICING = "apiDeletePricing";
    static API_ASSIGNED_TIERS = "apiGetAssignedTiers";
    static ASSIGN_PRICING = "AssignPricing.vue";
    static ADD_NEW_PRICING = "AddNewPricing.vue";
    static API_UPDATE_PRICING = "apiUpdatePricing";
    static API_CREATE_ROLE = "apiCreateRole.js";
    static API_UPDATE_ASSIGNED_TIERS = 'apiUpdateAssignedTiers.js';
    static API_ASSIGN_TIERS = 'apiAssignTiers.js';
    static API_CREDIT_NOTE = 'apiCreateCreditNote.js'
    static API_DEBIT_NOTE = 'apiCreateDebitNote.js';
    static API_TOOLS_CLASSES = 'apiToolsClasses.js';
    static CLASSES = 'Classes.vue';
    static API_ADD_AIRLINE_CLASS = 'apiAddAirlineClass.js';
    static API_GET_CREDIT_NOTE = 'apiGetCreditNote.js';
    static API_GET_DEBIT_NOTE = 'apiGetDebitNote.js';
    static API_SEARCH_RESERVATION = 'apiSearchReservationByB2b.js';

    static APP_TOAST = 'appToast.vue';
    static MAIN_FILE = 'main';
    static API_CREATE_BOOKING = 'apiCreateBooking';
    static API_CREATE_BOOKING_FOR_HOTEL = 'apiCreateBookingForHotel';

    static API_MANAGE_AGENTS = 'apiManageAllAgents';
    static PAYMENT_SETUP = "PaymentSetup";
    static C_PAYMENT_TYPES = "cPaymentType.vue";
    static API_ACTIVATE_AGENT = 'apiActivateAgent.js';
    static API_EDIT_AGENT = 'apiEditAgent.js';
    static API_GET_PAYMENT_LIST_AGT_MANAGE = "apiGetPaymentListAgtManage.js";
    static API_GET_TICKET_QUEUE = "apiGetTicketingQueueList.js";
    static API_GET_MY_BOOKINGS = "apiGetMyBookingsList.js";
    static API_FORGOT_PASSWORD = "apiForgotPassword.js"
    static API_RESET_PASSWORD = "apiResetPassword.js";
    static API_BALANCE_DETAIL = 'apiBalanceDetail.js';
    static API_GET_SETTINGS = 'apiGetSettings.js';
    static C_BOOKINGSTATUS = 'cBookingStatus';
    static API_GET_ROUTES_FOR_EDIT = 'apiGetRoutesForEdit';
    static API_MANAGE_ROUTES = 'apiManageRoutes';
    static API_CREATE_ROUTE = 'apiCreateRoute';
    static API_CREATE_AIRPORT = 'apiCreateAirport';
    static API_EDIT_AIRPORT = 'apiEditAirport';
    static API_GET_AIRPORT = 'apiGetAirports';
    static API_GET_ORDER_DETAILS_VIEW = 'apiGetOrderDetailsForView';
    static API_GET_ORDER_DETAILS_VIEW_NEW = 'apiGetOrderDetailsForViewNew';
    static API_GET_AIRPORTS_BY_COUNTRY_CODE = 'apiGetAirportsByCountryCode';
    static API_GET_TAX_SETUP_BY_COUNTRY = 'apiGetTaxSetupByCountry';

    static API_GET_ALL_CONTRACT = 'apiGetAllContract'
    static API_CREATE_CONTRACT = 'apiCreateContract'
    static API_UPDATE_CONTRACT = 'apiUpdateContract'
    static API_GET_ALL_AIRLINES = 'apiGetAllAirlines'
    static API_GET_CRS_PROVIDERS = 'apiGetCrsProviders'
    static API_DELETE_CONTRACT = 'apiDeleteContract'
    static API_CRS_GET_FARE_RULE = 'apiCRSGetFareRule'
    static API_CRS_FARE_VIEW = 'apiCrsFareView'

    static API_CREATE_AGENT_GROUP = "apiCreateAgentGroup"
    static API_GET_B2B_GROUP_LIST_WITH_B2B = "apiGetB2bGroupList"
    static API_UPDATE_B2B_CONTRACT = "apiUpdateB2bContract"
    static API_DELETE_B2B_CONTRACT = "apiDeleteB2bContract"
    static API_GET_B2B_GROUP_LIST = "apiGetB2bGrpList"

    static API_GET_AGENT_USER_BY_ORDER_ID = "apiGetAgentUserByOrderId";
    static API_SEND_VERIFICATION_CODE = "apiSendVerificationCode"
    static API_VERIFY_CODE = "apiVerifyCode"
    static API_ISSUED_VERIFIED_ORDER_TICKET = "apiIssuedVerifiedOrderTicket"

    static API_CREATE_CUSTOMER_PROFILE = "apiCreateCustomerProfile"
    static API_GET_ALL_SUB_AGENT = "apiGetAllSubAgent";
    static API_GET_SUB_AGENT_PAYMENT = "apiSubAgtPayment";
    static API_EDIT_SUB_AGENT = "apiEditSubAgent";

    static API_GET_CITIES_HOTEL_BOOKING = "apiGetCitiesForHotelBooking";
    static API_HOTEL_SEARCH_RESULT = "apiHotelSearchResults"
    static APT_ROOM_SEARCH = 'apiRoomSearch';
    static API_PRICING_ROOM = "apiPricingRoom.js";


    static API_GET_NOTIFICATION_SETTINGS = 'apiGetNotificationSettings';
    static API_UPDATE_EMAIL = 'apiUpdateEmail';
    static API_UPDATE_ACTIVATION = 'apiUpdateNotification';

    static API_GET_SUPPLIER_GROUP = 'apiGetSupplierGroup.js';
    static API_DELETE_SUPPLIER_GROUP = 'apiDeleteSupplierGrp.js';
    static API_CREATE_SUPPLIER_GROUP = 'apiCreateSupplierGrp.js';
    static API_UPDATE_SUPPLIER_GROUP = 'apiUpdateSupplierGrp.js';

    static API_GET_ALL_HOTELS = 'apiGetAllHotels.js';
}

export class API_VALUES {
    static ORG_ID = null;
}

// export class COUNT_CONTROL
// {
//     static CAROUSEL = { min:1 , max:10 };   // no of objects to edit on modal
//     static CUS_RATING = { min:3 , max:10 }; // no of objects to edit on modal
//     static STAR_RATING = { min:3,max:10 };  // user input field control --> value in star_rating object
// }

// export class DEFAULT_MSG
// {
//     static USER_MSG = "Hello";
//     static BOT_MSG  = "Hi";
// }

// export class BOT_SUG_COMP
// {
//     static BUTTON = "button";
//     static STAR_RATING = "starrating";
//     static CAROUSEL = "carousel";
//     static SCALE = "scale";
//     static CALENDAR = "calendar";
//     static TIME = "time";
//     static CUSTOM_RATING = "customrating";
//